import React from "react";
import { Link } from "react-router-dom";
import { blogs } from "../data/blogs";

function Blog() {
  return (
    <>
      <section className="inner-banner-sec">
        <div className="container-fluid add-padding-2">
          <div className="inner-bg-img">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12 align-self-center">
                <div
                  className="banner_text wow fadeInLeft"
                  data-wow-duration="2s"
                >
                  <h1>
                    <span>Blog</span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="blog-sec inner-blog-sec">
        <div className="container">
          <div className="row">
            {blogs.map((blog) => (
              <div
                className="col-xl-4 col-lg-6 col-md-6 col-sm-9 col-12"
                key={blog.id}
              >
                <div className="blog-box">
                  <img src={blog.image} alt={blog.title} />
                  <div className="blog-detail">
                    <ul>
                      <li>
                        <i className="fa-regular fa-user" /> by {blog.author}
                      </li>
                    </ul>
                    <h4>{blog.title}</h4>
                    <Link to={`/blog/${blog.slug}`}>Read More</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </>
  );
}

export default Blog;
